import React from 'react';
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
} from '@mui/material';
import { Field } from 'redux-form';
import { ReactSelect } from 'components/form/field/react-select';
import { ApplicationManagerClient } from 'clients/application-manager-client';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import { RolesEnum, talkdeskInnersections, talkdeskLinesSpecialties, ringGroupSubSections, TalkdeskDynamicFieldsEnum } from '../../constants';
import { cpStyle } from '../../index.styles';
import talkdesk01 from '../../../../../lib/logos/talkdesk01.png';
import talkdesk02 from '../../../../../lib/logos/talkdesk02.png';
import { IFields } from '../../table/types';

interface ISubFormProps {
  formTitle: string;
  fieldsInfo: IFields[];
  customerId: number;
  talkdeskPrimaryRef: any;
  talkdeskSecondaryRef: any;
  talkdeskCardiologyPrimaryRef: any;
  talkdeskCardiologySecondaryRef: any;
  setFieldValue: (field: string, value: any) => void;
}

export const Talkdesk: React.FC<ISubFormProps> = (props:ISubFormProps): JSX.Element => {
  const useStyles = makeStyles(cpStyle);
  const classes = useStyles();
  const MAX_LENGTH_INPUT = '100';

  const {
    formTitle,
    fieldsInfo,
    customerId,
    talkdeskPrimaryRef,
    talkdeskSecondaryRef,
    talkdeskCardiologyPrimaryRef,
    talkdeskCardiologySecondaryRef,
    setFieldValue,
  } = props;

  const [ringCentralOpList, setRingCentralOpList] = React.useState<{ label: string; value: number }[]>([]);
  const [talkdeskPrimary, setTalkdeskPrimary] = React.useState<{ label: string; value: number }[]>([]);
  const [talkdeskSecondary, setTalkdeskSecondary] = React.useState<{ label: string; value: number }[]>([]);
  const [talkdeskCardiologyPrimary, setTalkdeskCardiologyPrimary] = React.useState<{ label: string; value: number }[]>([]);
  const [talkdeskCardiologySecondary, setTalkdeskCardiologySecondary] = React.useState<{ label: string; value: number }[]>([]);

  const handleTalkdeskPrimaryChange = (primaryGroup: { label: string; value: number }[]): void => {
    setTalkdeskPrimary(primaryGroup);
  };

  const handleTalkdeskSecondaryChange = (secondaryGroup: { label: string; value: number }[]): void => {
    setTalkdeskSecondary(secondaryGroup);
  };

  const handleCardiologyPrimaryChange = (cardiology: { label: string; value: number }[]): void => {
    setTalkdeskCardiologyPrimary(cardiology);
  };

  const handleCardiologySecondaryChange = (cardiology: { label: string; value: number }[]): void => {
    setTalkdeskCardiologySecondary(cardiology);
  };

  React.useEffect(() => {
    const ringCentralOpUserList = async () => {
      const ringCentralOpUsers = await ApplicationManagerClient.fetchRoleListUsers(`${RolesEnum.LIAISON_CENTRAL_OPS},${RolesEnum.PHARMACIST_CENTRAL_OPS},${RolesEnum.LIAISON_DISPENSING},${RolesEnum.PHARMACIST_DISPENSING}`, customerId);
      if (ringCentralOpUsers && ringCentralOpUsers.data && ringCentralOpUsers.data.length) {
        setRingCentralOpList(ringCentralOpUsers.data.map(t => {
          return {
            value: t.id,
            label: t.display_name,
          };
        }));
      }
    };
    ringCentralOpUserList();
  }, []);

  React.useEffect(() => {
    talkdeskPrimaryRef.current = talkdeskPrimary;
  }, [talkdeskPrimary]);

  React.useEffect(() => {
    talkdeskSecondaryRef.current = talkdeskSecondary;
  }, [talkdeskSecondary]);

  React.useEffect(() => {
    talkdeskCardiologyPrimaryRef.current = talkdeskCardiologyPrimary;
  }, [talkdeskCardiologyPrimary]);

  React.useEffect(() => {
    talkdeskCardiologySecondaryRef.current = talkdeskCardiologySecondary;
  }, [talkdeskCardiologySecondary]);

  React.useEffect(() => {
    const tempLoopFields = Object.values(TalkdeskDynamicFieldsEnum) as string[];
    if (fieldsInfo.length) {
      for (const fieldInfo of fieldsInfo) {
        if (
          fieldInfo.fieldName &&
          tempLoopFields.includes(fieldInfo.fieldName) &&
          Array.isArray(fieldInfo.value) &&
          fieldInfo.value.length
        ) {
          if (fieldInfo.fieldName === TalkdeskDynamicFieldsEnum.TALKDESK_PRIMARY) {
            setTalkdeskPrimary(fieldInfo.value);
          }
          if (fieldInfo.fieldName === TalkdeskDynamicFieldsEnum.TALKDESK_SECONDARY) {
            setTalkdeskSecondary(fieldInfo.value);
          }
          if (fieldInfo.fieldName === TalkdeskDynamicFieldsEnum.TALKDESK_CARDIOLOGY_PRIMARY) {
            setTalkdeskCardiologyPrimary(fieldInfo.value);
          }
          if (fieldInfo.fieldName === TalkdeskDynamicFieldsEnum.TALKDESK_CARDIOLOGY_SECONDARY) {
            setTalkdeskCardiologySecondary(fieldInfo.value);
          }
        }
      }
    }
  }, [fieldsInfo]);

  return (
    <Grid item xs={12}>
      <Accordion className={classes.accordionheader}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={classes.expandIconColor} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>
            <Tooltip title={formTitle} placement="right-end">
              <span className={classes.accordionTitle}>{`${formTitle}`}</span>
            </Tooltip>
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.AccordionDetailsForm} style={{ paddingLeft: '2px', paddingRight: '2px' }}>
          <Grid item xs={12}>
            <Accordion className={classes.innerAccordionheader}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className={classes.innerExpandIconColor} />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography>
                  <Tooltip title={formTitle} placement="right-end">
                    <span className={classes.innerAccordionTitle}>{`${talkdeskInnersections.DOWNLOAD_TALKDESK}`}</span>
                  </Tooltip>
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.AccordionDetailsForm}>
                <p>
                  Click on the link below to download <b>Talkdesk</b> to desktop <a href="https://trellisrx.mytalkdesk.com/atlas/download" target="_blank" rel="noreferrer">https://trellisrx.mytalkdesk.com/atlas/download</a> <br />
                  Click <b>Download</b> button. <br />
                  Select <b>Open File</b> once download is complete. <br />
                </p>
                <img src={talkdesk01} alt="trellis account" className={classes.talkdeskLogo01} />
                <p>
                  In Account Section, put <b>trellisrx</b> (all lowercase) <br />
                  Click on <b>Login with Microsoft</b> <br />
                </p>
                <img src={talkdesk02} alt="account section" className={classes.talkdeskLogo02} />
                <p>
                  <b>Log in</b> with TrellisRX email and password if prompted.
                </p>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12}>
            <Accordion className={classes.innerAccordionheader}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className={classes.innerExpandIconColor} />}
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <Typography>
                  <Tooltip title={formTitle} placement="right-end">
                    <span className={classes.innerAccordionTitle}>
                      {`${talkdeskInnersections.TALKDESK_LINES}`}
                    </span>
                  </Tooltip>
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.AccordionDetailsForm}>
                <Grid item xs={12} className={classes.talkdeskLinesTitle}>
                  <span>
                    {`${talkdeskInnersections.TALKDESK_LINES}`}
                  </span>
                </Grid>
                <Grid item xs={12} className={classes.talkdeskLinesSubTitle}>
                  <span>
                    {`${talkdeskLinesSpecialties.CARDIOLOGY}:`}
                  </span>
                </Grid>
                <Grid item xs={12} className={classes.talkdeskLinesSubTitle}>
                  <span>
                    {`${talkdeskLinesSpecialties.ONCOLLOGY}:`}
                  </span>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12}>
            <Accordion className={classes.innerAccordionheader}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className={classes.innerExpandIconColor} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>
                  <Tooltip title={formTitle} placement="right-end">
                    <span className={classes.innerAccordionTitle}>
                      {`${talkdeskInnersections.RING_GROUPS}`}
                    </span>
                  </Tooltip>
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.AccordionDetailsForm}>
                <Grid container spacing={3} className={classes.rowMarginTop}>
                  <Grid item xs={12} className={classes.talkdeskLinesTitle}>
                    <span>
                      {`${ringGroupSubSections.CENTRAL_OPS_DISPENSING}`}
                    </span>
                  </Grid>
                  <Grid item xs={12}>
                    <ReactSelect
                      name="talkdesk_primary"
                      label="Primary Group:"
                      isMulti
                      value={talkdeskPrimary}
                      fields={ringCentralOpList}
                      handleOnChange={handleTalkdeskPrimaryChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <ReactSelect
                      name="talkdesk_secondary"
                      label="Secondary Group:"
                      isMulti
                      value={talkdeskSecondary}
                      fields={ringCentralOpList}
                      handleOnChange={handleTalkdeskSecondaryChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.talkdeskLinesTitle}>
                    <span>
                      {`${ringGroupSubSections.CARDIOLOGY}`}
                    </span>
                  </Grid>
                  <Grid item xs={12}>
                    <ReactSelect
                      name="talkdesk_cardiology_primary"
                      label="Primary Group:"
                      isMulti
                      value={talkdeskCardiologyPrimary}
                      fields={ringCentralOpList}
                      handleOnChange={handleCardiologyPrimaryChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <ReactSelect
                      name="talkdesk_cardiology_secondary"
                      label="Secondary Group:"
                      isMulti
                      value={talkdeskCardiologySecondary}
                      fields={ringCentralOpList}
                      handleOnChange={handleCardiologySecondaryChange}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};
